import React from 'react';
import { getUsers, addUser, updateUser, deleteUser } from '../services/userApi';
import { FormField } from '../components/forms/generic/GenericFormTypes';

export interface UserData {
  id: number;
  name: string;
  surname: string;
  phone_number: string;
  identification_number: string;
  management: string;
  office: string;
  authorization_level: 'Admin' | 'User';
}

export const emptyUser: Omit<UserData, 'id'> = {
  name: '',
  surname: '',
  phone_number: '',
  identification_number: '',
  management: '',
  office: '',
  authorization_level: 'User',
};

export const userCrudOperations = {
  getAll: getUsers,
  create: addUser,
  update: updateUser,
  delete: deleteUser,
};

// Error messages are now handled by the centralized error handling system

export const userFormFields: FormField[] = [
  {
    key: 'name',
    label: 'Ad',
    type: 'text' as const,
    placeholder: 'Ad',
    required: true,
  },
  {
    key: 'surname',
    label: 'Soyad',
    type: 'text' as const,
    placeholder: 'Soyad',
    required: true,
  },
  {
    key: 'phone_number',
    label: 'Telefon Numarası',
    type: 'tel' as const,
    placeholder: 'Telefon Numarası',
    required: true,
  },
  {
    key: 'identification_number',
    label: 'TC Kimlik No',
    type: 'text' as const,
    placeholder: 'TC Kimlik No',
    required: true,
  },
  {
    key: 'management',
    label: 'Departman',
    type: 'select' as const,
    placeholder: 'Departman Seçin',
    required: false,
    options: [], // Bu dinamik olarak doldurulacak
  },
  {
    key: 'office',
    label: 'Büro',
    type: 'select' as const,
    placeholder: 'Büro Seçin',
    required: false,
    options: [], // Bu dinamik olarak doldurulacak
  },
  {
    key: 'authorization_level',
    label: 'Yetki Seviyesi',
    type: 'select' as const,
    required: true,
    options: [
      { value: 'User', label: 'Kullanıcı' },
      { value: 'Admin', label: 'Admin' },
    ],
  },
];

export const userTableColumns = [
  { header: 'ID', accessor: (user: UserData) => user.id },
  { header: 'Ad', accessor: (user: UserData) => user.name },
  { header: 'Soyad', accessor: (user: UserData) => user.surname },
  { header: 'Telefon', accessor: (user: UserData) => user.phone_number },
  {
    header: 'TC Kimlik',
    accessor: (user: UserData) => user.identification_number,
  },
  { header: 'Departman', accessor: (user: UserData) => user.management },
  { header: 'Büro', accessor: (user: UserData) => user.office },
  {
    header: 'Yetki',
    accessor: (user: UserData) => (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${
          user.authorization_level === 'Admin'
            ? 'bg-purple-100 text-purple-800'
            : 'bg-blue-100 text-blue-800'
        }`}
      >
        {user.authorization_level}
      </span>
    ),
  },
];

export const userSearchableFields = ['name', 'surname', 'management', 'office'];
